module.exports = __webpack_public_path__ + "resources/img/ico_clip.cec9f78323aa21f1ad494e663f396275.png";